import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { filter_movie } from "../../api/filterMovie.js";
import { countryListByRegion } from "../../utility/utility.js";

export const getFilterResult = createAsyncThunk(
  "filter/filterResult",
  async (filterList, { getState }) => {
    let countryConfig = getState().apiUtility.apiUtility.countryConfig;

    function formatRegion (rawRegion) {
      let format_country_list= rawRegion.filter(item => !item.includes("Region")).map((item) => {
        let targetCountry = countryConfig.find((country) => country["english_name"] == item)
        return targetCountry["iso_3166_1"];
      })

      let region_list = rawRegion.filter(item => item.includes("Region")).forEach(element => {
        let countries = countryListByRegion[element];
        countries.forEach(country => format_country_list.push(country))
      });

      return Array.from(new Set(format_country_list));
    }

    let formatFilterList = {
      type: filterList.type,
      genres: filterList.genre,
      keywords: filterList.keyword,
      runtime_from: filterList.runtime[0],
      runtime_to: filterList.runtime[1],
      region: formatRegion(filterList.region),
      year_from: filterList.period[0],
      year_to: filterList.period[1],
      sort: filterList.sort,
      page: filterList.page
    };
    console.log(formatFilterList)
    const filterResult_response = await filter_movie(formatFilterList);
    //const formatResponse = filterResult_response.results;
    return filterResult_response;
  }
);

const FilterSlice = createSlice({
  name: "filter",
  initialState: {
    filterList: {
      type: 0,
      genre: [],
      keyword: [],
      runtime: [],
      region: [],
      period: [],
      sort: [],
      page: 1,
    },
    filterStatementList: {
      genre: [],
      keyword: [],
      runtime: [],
      region: [],
      period: [],
    },
    filterResultList: {
      totalPages: null,
      totalResults: null,
      filterResult: [],
      filterResultLoading: true,
      filterResultError: false,
    },
  },
  reducers: {
    modifyFilterList: (state, action) => {
      const { field, payload } = action.payload;
      return {
        ...state,
        filterList: {
          ...state.filterList,
          [field]: payload,
        },
      };
    },
    modifyFilterStatementList: (state, action) => {
      const { field, payload } = action.payload;
      return {
        ...state,
        filterStatementList: {
          ...state.filterStatementList,
          [field]: payload,
        },
      };
    },
    resetFilterResultList: (state) => {
      state.filterResultList.filterResult = [];
      state.filterResultList.filterResultLoading = false;
      state.filterResultList.filterResultError = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFilterResult.pending, (state) => {
        state.filterResultList.filterResultLoading = true;
        state.filterResultList.filterResultError = false;
      })
      .addCase(getFilterResult.fulfilled, (state, action) => {
        state.filterResultList.filterResultLoading = false;
        state.filterResultList.totalResults = action.payload.total_results;
        state.filterResultList.totalPages = action.payload.total_pages;
        state.filterResultList.filterResult = action.payload.results;
        state.filterResultList.filterResultError = false;
      })
      .addCase(getFilterResult.rejected, (state, action) => {
        state.filterResultList.filterResultLoading = false;
        state.filterResultList.filterResultError = action.error.message;
      });
  },
});

//Export FilterReducer & Action Creators
export const { modifyFilterList, modifyFilterStatementList } =
  FilterSlice.actions;
export default FilterSlice.reducer;
